import { isAxiosError } from "axios";
import { ResourceValidationErrorDTO } from "../../generated/dto/ResourceValidationErrorDTO";
import { ResourceValidationErrorResponse } from "../../generated/dto/ResourceValidationErrorResponse";

/**
 * Backend field-level validation errors surface as HTTP 422 with a
 * `ResourceValidationErrorResponse` body (see `ksp.base.ResourceValidationException`
 * and Compass's `StatusPages` handler for it). This unwraps a caught error from a
 * generated `*ApiClient`/`*FrontendService` call into that field list, or returns
 * `null` if the error is not a 422 resource-validation failure so callers can fall
 * back to their own generic error handling.
 */
export const extractResourceValidationErrors = (
  error: unknown,
): ResourceValidationErrorDTO[] | null => {
  if (!isAxiosError(error) || error.response?.status !== 422) {
    return null;
  }
  const body = error.response.data as Partial<ResourceValidationErrorResponse> | undefined;
  if (!body || !Array.isArray(body.errors)) {
    return null;
  }
  return body.errors;
};

/**
 * Convenience lookup for a single field's message out of a
 * `ResourceValidationErrorDTO[]` (e.g. to bind to a form field's error slot).
 * `field: null` entries are resource-level (not tied to one field) and are only
 * returned when `field` is passed as `null`.
 */
export const findResourceValidationError = (
  errors: ResourceValidationErrorDTO[] | null,
  field: string | null,
): string | undefined => errors?.find((error) => error.field === field)?.message;

